import {
  FulfillmentGroup,
  FulfillmentGroupData,
} from "@redotech/redo-model/fulfillments/fulfillment-group";
import { useNavigate } from "react-router-dom";
import { ScanningModal } from "../scanning-context/types";
import { ClosedFulfillmentGroupModal } from "./closed-fulfillment-group-modal";
import { IncompleteVerificationModal } from "./incomplete-verification-modal";
import { MergedPackingSlipScannedModal } from "./merged-packing-slip-scanned-modal";
import { FulfillmentGroupSelectModal } from "./multiple-order-select-modal";
import {
  PartiallyFulfillModal,
  PartiallyFulfillModalFormData,
} from "./partially-fulfill-modal";
import { ToteOrderSelectionModal } from "./tote-order-selection-modal";
import { WrongBarcodeModal } from "./wrong-barcode-modal";

export function ScanningModals({
  doPartialFulfill,
  handleSelectFulfillmentGroup,
  handleNavigate,
  openModal,
  openModalData,
  onClose,
  relevantFulfillmentGroups,
}: {
  doPartialFulfill: (data: PartiallyFulfillModalFormData) => void;
  handleSelectFulfillmentGroup: (group: FulfillmentGroup) => void;
  handleNavigate: (path: string) => void;
  openModal?: ScanningModal;
  openModalData?: any;
  onClose: () => void;
  relevantFulfillmentGroups: FulfillmentGroup[];
}) {
  const navigate = useNavigate();

  return (
    <>
      <FulfillmentGroupSelectModal
        identifier={openModalData}
        onClose={onClose}
        onSelect={handleSelectFulfillmentGroup}
        open={openModal === ScanningModal.FULFILLMENT_GROUP_SELECTION}
        relevantFulfillmentGroups={relevantFulfillmentGroups}
      />
      <ToteOrderSelectionModal
        isOpen={openModal === ScanningModal.TOTE_ORDER_SELECTION}
        onClose={onClose}
      />
      {openModal === ScanningModal.PARTIAL_FULFILL && (
        <PartiallyFulfillModal
          onCloseRequested={onClose}
          onSubmit={doPartialFulfill}
        />
      )}
      <IncompleteVerificationModal
        onBack={() => {
          onClose();
        }}
        onContinue={() => {
          const path: string = openModalData;
          onClose();
          if (path) {
            handleNavigate(path);
          }
        }}
        open={openModal === ScanningModal.INCOMPLETE_VERIFICATION}
      />
      <ClosedFulfillmentGroupModal
        onBack={() => {
          onClose();
          navigate("../");
        }}
        onContinue={onClose}
        open={openModal === ScanningModal.CLOSED_GROUP_WARNING}
      />
      {openModal === ScanningModal.WRONG_BARCODE && (
        <WrongBarcodeModal barcode={openModalData} onClose={onClose} />
      )}
      {openModal === ScanningModal.MERGED_PACKING_SLIP_SCANNED && (
        <MergedPackingSlipScannedModal
          fulfillmentGroupData={
            openModal === ScanningModal.MERGED_PACKING_SLIP_SCANNED
              ? (openModalData as FulfillmentGroupData)
              : undefined
          }
          onCancel={() => {
            onClose();
            handleNavigate("../scan");
          }}
          onContinue={() => {
            onClose();
            handleNavigate(openModalData._id);
          }}
          open={openModal === ScanningModal.MERGED_PACKING_SLIP_SCANNED}
        />
      )}
    </>
  );
}
